import type { AuctionFilterState } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import type { DynamicAuctionList } from '@autobid/strapi-integration/rest/components'

interface PropsFiltered {
  lang: string
  filters: AuctionFilterState
  props: {
    data: DynamicAuctionList
  }
}

export const auctionListQueryKey = {
  all: () => ['auctions'] as const,
  filtered: ({ lang, filters, props }: PropsFiltered) => ['auctions', lang, filters, props] as const,
}
